import { useState, useRef, useEffect } from "react";
import styles from "./CustomAutocomplete.module.scss";

const NewAutocomplete = ({
  options,
  optionLabel,
  optionDisplay = optionLabel,
  maxDisplayOptions = -1,
  onSelect,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredOptions = options.filter(
    (option) =>
      optionLabel(option).toLowerCase().includes(inputValue.toLowerCase()) ||
      inputValue === ""
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className={styles.container}>
      <input
        className={styles.input}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        onFocus={() => setIsOpen(true)}
        placeholder="Search Users"
      />
      {isOpen && (
        <ul className={styles.options}>
          {filteredOptions.length === 0 ? (
            <li className={styles.option}>Nessun risultato trovato</li>
          ) : (
            filteredOptions.map((option) => (
              <li
                className={styles.result}
                key={option.id}
                onClick={() => setInputValue(optionLabel(option))}
              >
                {optionDisplay(option)}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default NewAutocomplete;
